import { DentalNotationFormat } from '@/shared/api/protocol-ts/model/dto_organization_pb';

import { DentalNotations } from '@/entities/tooth';

export enum CompanyInfoTitles {
  Emails = 'Emails',
  Phones = 'Phones',
  WebSite = 'WebSite',
  Country = 'Country',
  City = 'City',
  Address = 'Address',
  ZipCode = 'ZipCode',
  Region = 'Region',
}

export enum TabValue {
  CompanyInfo = 'CompanyInfo',
  Staff = 'Staff',
  Templates = 'Templates',
  Analytics = 'Analytics',
  BillingInfo = 'BillingInfo',
  SubscriptionPlans = 'SubscriptionPlans',
  APIKeys = 'APIKeys',
}

export const CONTACTS_SORT = [
  'Country',
  'Region',
  'City',
  'Address',
  'ZipCode',
  'Emails',
  'Phones',
  'WebSite',
];

export const DENTAL_NOTATIONS = [
  {
    value: DentalNotationFormat.DentalNotationFormatISO,
    label: DentalNotations.ISO,
  },
  {
    value: DentalNotationFormat.DentalNotationFormatUniversal,
    label: DentalNotations.UNIVERSAL,
  },
];

export const EMPTY_VALUE = '—';

export const API_KEY_DATE_FORMAT: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
};

export const API_KEY_COMMENT_MAX_LENGTH = 500;
